import { render } from "./Input.vue?vue&type=template&id=16acc8c6&scoped=true&ts=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=16acc8c6&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16acc8c6"]])

export default __exports__